import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import withRouter from "../../../data/shared/withRouter";
import { getUser, isFetchingUser } from "../../../data/account/selectors/user";
import App from "../../account/components/App";
import { fetchUserSession } from "../../../data/account/actions/userSession";
import { showPaymentFailure, showPaymentSuccess} from "../../../data/followup/actions/followup";

class AppContainer extends Component {
    static propTypes = {
        isFetching: PropTypes.bool,
        fetchUserSession: PropTypes.func,
        showPaymentSuccess: PropTypes.func,
        showPaymentFailure: PropTypes.func
    };

    componentDidMount() {
        this.props.fetchUserSession();
    }

    render() {
        const { isFetching, user, Component } = this.props;
        const {params, searchParams} = this.props.router

        return <App loading={isFetching || user == null} >
            <Component params={params} searchParams={searchParams}/>
        </App>;
    }
}

export default connect(
    (state) => ({
        user: getUser(state),
        isFetching: isFetchingUser(state),
    }),
    dispatch => bindActionCreators({ showPaymentSuccess, showPaymentFailure, fetchUserSession }, dispatch)
)(withRouter(AppContainer));
